(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-product-banner-ambient')) {
    customElements.define('custom-product-banner-ambient', class extends HTMLElement {
      connectedCallback() {
        this.onColorClick = (event) => {
          const option = event.target.closest('[data-ambient-option]');
          if (option && option.closest('custom-product-banner-ambient') === this) this.selectColor(option);
        };
        this.addEventListener('click', this.onColorClick);
        const initial = this.querySelector('[data-ambient-option][aria-pressed="true"]');
        if (initial) this.selectColor(initial);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onColorClick);
      }
      selectColor(selected) {
        this.style.setProperty('--cpb-glow', selected.dataset.color);
        this.querySelectorAll('[data-ambient-option]').forEach((option) => {
          const active = option === selected;
          option.setAttribute('aria-pressed', String(active));
          option.querySelector('[data-color-status]').textContent = active ? this.dataset.activeLabel : this.dataset.selectLabel;
        });
        this.querySelector('[data-current-name]').textContent = selected.dataset.name;
        this.querySelector('[data-current-hex]').textContent = selected.dataset.color.toUpperCase();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
